export default {
  Version__BUTTON: "Ok, reload now",
  Version__BUTTON_GROUP_ARIA_NEXT: "Next",
  Version__BUTTON_GROUP_ARIA_PREVIOUS: "Previous",
  Version__TEXT:
    "The application version currently being used for this site is out of date and requires a browser reload to continue.",
  Version__TITLE: "Browser reload needed",
};
